import { render, staticRenderFns } from "./list_appointments.vue?vue&type=template&id=eab948b8&scoped=true"
import script from "./list_appointments.vue?vue&type=script&lang=js"
export * from "./list_appointments.vue?vue&type=script&lang=js"
import style0 from "./list_appointments.vue?vue&type=style&index=0&id=eab948b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab948b8",
  null
  
)

export default component.exports